<template>
  <div>
    <el-container v-loading="!loadingEvent">

      <div id="containerBar">
        <div class="">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="300px" height="300px" viewBox="0 0 300 300" enable-background="new 0 0 300 300" xml:space="preserve">
            <path fill="#04ACFF" id="waveShape" d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4 c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9 c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z" ></path>
          </svg>
        </div>
      </div>

      <div id="containerGauge">
        <img src="../media/Gauge.png" id="gauge">
        <img src="../media/Pointer.png" id="pointer">
      </div>

      <div id="containerInfo">
        <img id="oven" src="../media/oven.png">
        <p> Name: {{$attrs.deviceId}}</p>
        <p> Max. temperature this month: {{maxTemperatureMonth}} </p>
        <p> Resistors wear: {{resistorWearPerc}}% </p>
        <p> Fluid level: {{fluidLevelPerc}}% </p>
      </div>
    </el-container>
    <app-email  :name="$attrs.deviceId"
                :resistorWear="resistorWearPerc"
                :fluidLevel="fluidLevelPerc"></app-email>
  </div>
</template>

<script>
  import axios from 'axios';
  import { Draggable } from 'draggable-vue-directive'

  export default {
    name: 'DeviceProperties',
    directives: {
      Draggable,
    },
    data(){
      return{
        /* This month dates*/
        thisMonthStart : new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        thisMonthEnd : new Date(),
        /* Month variables */
        turnOnsMonth: '/',
        maxTemperatureMonth: '/',
        resistorWearPerc: '/',
        fluidLevelPerc: '/',
        /* Variable used for the loading event */
        loadingEvent: 0,
      }
    },
    methods:{
      transformDate: function (data) {
        let date = new Date(data)
        let year = date.getFullYear();
        let month = ("0" + date.getMonth()).slice(-2);
        let day = ("0" + date.getDay()).slice(-2);
        let hours = ("0" + date.getHours()).slice(-2);
        let minutes = ("0" + date.getMinutes()).slice(-2);
        let seconds = ("0" + date.getSeconds()).slice(-2);

        return year + "_" + month + "_" + day + "_" + hours + "_" + minutes + "_" + seconds;
      },
      showError: function () {
        var app = this;
        /* Error allData Popup */
        app.$message({
          showClose: true,
          message: "ERROR " + error.response.status + " - " + error.response.statusText,
          type: 'error'
        });
      },
      maxTemperatureThisMonth: function () {
        var app = this;
        let maxTemperatureMonthQuery = `SELECT h FROM event WHERE utctime>${app.thisMonthStart.getTime()} ORDER BY h DESC LIMIT 1`;

        axios.post(`https://iiot.dave.eu/api/customQuery`,{
          device: app.$attrs.deviceId,
          startPoint: app.transformDate(app.thisMonthStart),
          finishPoint:app.transformDate(app.thisMonthEnd),
          query: maxTemperatureMonthQuery
        }).then(function (response) {
            if(response.data.length > 0)
              app.maxTemperatureMonth = Math.floor(response.data[0].h) + " °C";
            else
              app.maxTemperatureMonth = '/'
            app.loadingEvent++;

          }).catch(function (error){
            app.showError();
            console.log(error.response)
            app.loadingEvent++;
          })
      },
      getStatistics: function () {
        var app = this;

        axios.post(`https://iiot.dave.eu/api/statistics`,{
          device: app.$attrs.deviceId,
        }).then(function (response) {
          app.resistorWearPerc = response.data.resistorWearPerc;
          app.fluidLevelPerc = response.data.fluidLevelPerc;

          document.getElementById("pointer").style.transform = `rotate(${(response.data.resistorWearPerc*2.6)-130}deg)`;
          document.getElementById("containerBar").childNodes.item("div").classList.add('fill');
          document.querySelector('.fill').style.transform = `translateY(${((100-response.data.fluidLevelPerc)*0.78)+2}%)`;  // The percentage needs to go from 80% (empty) to 2% (full) so we just subtract 100 (since the response gives a percentage) and then * by 0.78 (the range) and add 2
        });
      }
    },
    created: function () {
      this.maxTemperatureThisMonth();
      this.getStatistics();
    },
  }
</script>

<style  scoped>
  /* Tablets and smaller */
  @media only screen and (max-width: 768px){
    #containerGauge{
      display: none;
    }
  }
  /* Very small devices */
  @media only screen and (max-width: 480px) {
    #containerBar{
      display: none;
    }
  }
  .el-container{
    min-height: 250px;
    display: flex;
    vertical-align: middle;
    justify-content: space-between;
  }
  p {
    text-align: left!important;
  }

  .el-container{
    min-height: 100vh;
  }
  #containerInfo{
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 2%;
    height: 20%;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    background-color: #ffffff;
  }

  #containerBar {
    border-radius: 15px;
    border: 1px solid #3e3e3e;
    width: 150px;
    height: 250px;
    background: linear-gradient(to bottom, rgba(128,184,85,1) 0%,rgba(234,202,68,1) 35%,rgba(234,202,68,1) 65%,rgba(239,77,77,1) 100%);
    overflow: hidden;
    backface-visibility: hidden;
    box-shadow: rgba(0, 0, 0, 0.12) 5px 5px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  }
  #containerBar div{
    transform: translateY(80%);
    transition: transform 3s cubic-bezier(.2, .4, .5, .3);
  }

  #containerBar #waveShape {
    animation-name: waveAction;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 0.5s;
    width: 300px;
    height: 150px;
    fill: #04ACFF;
  }

  #gauge{
    box-shadow: rgba(0, 0, 0, 0.12) 5px 5px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    border-radius:100px;
  }

  #pointer{
    height: 90px;
    position:relative;
    top: -80px;
    left: -50%;
    transform-origin: 44.44% 78.96%;
    transform: rotate(-90deg);
    transition: all .7s;
    transition-timing-function: cubic-bezier(.77,-0.82,.3,1.54);
  }

  @keyframes waveAction {
    0% {  transform: translate(-150px, 0);  }
    100% {  transform: translate(0, 0);  }
  }
</style>



// WEBPACK FOOTER //
// src/components/DeviceProperties.vue